export default "__VITE_ASSET__BCdiY6ch__"